import BibliographyPage from "./bibliography/bibliography";
import ExpertsPage from "./experts/experts";
import HomePage from "./home/home-page";
import InformationsPage from "./informations/informations";
import LegalNotice from "./informations/legal-notice";
import MoleculeDetail from "./molecules/molecule-detail";
import MoleculesPage from "./molecules/molecules-page";
import ArticlePage from "./news/article";
import NewsPage from "./news/news";
import SymptomDetail from "./symptoms/symptom-detail";
import SymptomsPage from "./symptoms/symptoms-page";
import Quizz from "./training/quizz";
import QuizzSelection from "./training/quizz-selection";
import TrainingPage from "./training/training-page";
import Auth from "./user/auth";
import ProfilePage from "./user/profile-page";
import UserBadge from "./user/user-badge";


export {
  HomePage,
  InformationsPage,
  MoleculesPage,
  MoleculeDetail,
  SymptomDetail,
  SymptomsPage,
  TrainingPage,
  BibliographyPage,
  NewsPage,
  ArticlePage,
  ExpertsPage,
  QuizzSelection,
  Quizz,
  UserBadge,
  Auth,
  ProfilePage,
  LegalNotice,
}
